export default {"src":"/_next/static/media/arrowLeftDarkGrey.54c0ab9e.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};